import React, {
  useState,
  Fragment,
  useEffect,
  useContext,
  useRef,
} from "react";
import { ChromePicker } from "react-color";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";
import FormHOC from "./FormHOC";
import { Store } from "../state/state";

let allDefineID = (id) => {
  let node = document.querySelector("#color-picker");

  console.log("NODE_CURRENT :", node);
  for (var i = 0; i < node.childNodes.length; i++) {
    var child = node.childNodes[i];
    if (child.nodeName !== "#text") child.setAttribute("id", id);

    console.log("child id :", child.id);
    allDefineID(child);
    // removeTest(child);
  }
};
function ColorPickerUI({ color, onChange, id }) {
  const [open, setOpen] = useState(false);
  const store = useContext(Store);

  const [newColor, setNewColor] = useState({ hex: color });
  const [scroll, setScroll] = useState();
  const ref = useRef();
  useEffect(() => {
    onChange(newColor);
  }, [newColor]);
  useEffect(() => {
    let setting = document.querySelector("#scroll-setting");
    setScroll(setting);
    // allDefineID(id);
  }, []);
  return useObserver(() => (
    <Fragment>
      <div
        id={id}
        className="flex-1 flex justify-between items-center   relative"
      >
        {store.selectEditor === id && (
          <div
            id={"color-bg"}
            className="fixed flex items-center  p-5 rounded  picker-COLOR-UI "
            style={{
              // transform: "translateX(-100%)",
              // top: scroll.getBoundingClientRect().top + store.scrollTop + "px",
              transform: `translateY(${
                100 - store.scrollTop + "px"
              })translateX(-96%)`,
              // bottom: scroll.scrollBotton + "px",
              height: "240px",
            }}
          >
            <ChromePicker
              ref={ref}
              id={"color-picker"}
              styles={{ height: "240px" }}
              // triangle="top"

              // color={newColor}
              onChangeComplete={(color) => {
                store.selectEditor = id;
                setOpen(false);
                setNewColor(color);

                console.log("COMPLETE = ", color);
              }}
              onChange={(color) => {
                store.selectEditor = id;
                const { r, g, b, a } = color.rgb;
                let result = `rgba(${r},${g},${b},${a})`;

                setNewColor(color);
                console.log("change selector EDITOR");
              }}
              color={newColor}
            />

            <span className="arrow-right ">▲</span>
          </div>
        )}
        <div
          id={id}
          className="rounded-lg shadow flex-1 h-8  border cursor-pointer"
          style={{ backgroundColor: newColor.hex }}
          onClick={(e) => {
            // if (store.selectEditor === id)
            //   console.log("top :", scroll.offsetTop);
          }}
        ></div>
      </div>
    </Fragment>
  ));
}

export default FormHOC(ColorPickerUI);
